import { render } from "./langueSwitch.vue?vue&type=template&id=0fdcc466&scoped=true"
import script from "./langueSwitch.vue?vue&type=script&lang=js"
export * from "./langueSwitch.vue?vue&type=script&lang=js"

import "./langueSwitch.vue?vue&type=style&index=0&id=0fdcc466&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fdcc466"]])

export default __exports__